// extracted by mini-css-extract-plugin
export default {"pageLayout":"CrmPageLayout_pageLayout__X8wZV","contentColumn":"CrmPageLayout_contentColumn__R9ePK"};